import { Controller } from "@hotwired/stimulus"

export default class ChildFrameNavigatorController extends Controller {
  static targets = ["frame"]
  static values = { media: String }

  load({ detail: { url } }) {
    if (!this.#mediaMatches()) return

    this.frameTarget.src = url
  }

  clear() {
    this.frameTarget.removeAttribute("src")
    this.frameTarget.replaceChildren()
  }

  #mediaMatches() {
    return !this.hasMediaValue || window.matchMedia(this.mediaValue).matches
  }
}
